module.exports = __webpack_public_path__ + "media/images/athletes/3580-76696696dab56942cbc9995dad75b6ae.png";